module.exports = __webpack_public_path__ + "static/media/search.f6ba5f23.svg";